import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import BrandMark from './BrandMark';

const FOOTER_LINKS = [
  { name: 'Planos para Médicos', url: '/#para-quem' },
  { name: 'Para Clínicas', url: '/#clinicas' },
  { name: 'Política de Privacidade', url: '/privacidade' },
  { name: 'Termos de Uso', url: '/termos' },
];

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ bgcolor: '#0A2038', color: '#fff', pt: 7, pb: 3 }}>
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2.5 }}>
              <BrandMark light size="medium" />
            </Box>
            <Typography variant="body2" sx={{ mb: 3, maxWidth: 320, color: 'rgba(255,255,255,0.7)', lineHeight: 1.7 }}>
              Planos de saúde inteligentes para médicos, clínicas e profissionais da saúde.
              Ajudamos você a avaliar alternativas ao seu plano atual com atendimento
              especializado.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton aria-label="WhatsApp" sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' }}>
                <WhatsAppIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="Instagram" sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' }}>
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="LinkedIn" sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' }}>
                <LinkedInIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: '1rem' }}>
              Institucional
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mb: 3 }}>
              {FOOTER_LINKS.map((link) => (
                <Box component="li" key={link.name} sx={{ mb: 1.25 }}>
                  <Link
                    {...(link.url.startsWith('/#')
                      ? { href: link.url }
                      : { component: RouterLink, to: link.url })}
                    underline="hover"
                    sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', '&:hover': { color: '#fff' }, transition: 'color 0.2s' }}
                  >
                    {link.name}
                  </Link>
                </Box>
              ))}
            </Box>
            <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255,255,255,0.55)', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Empresa responsável
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.25, color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>
              VITOR DE OLIVEIRA JUNIOR INFORMATICA
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.25, color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>
              CNPJ: 32.256.713/0001-07
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>
              São Bernardo do Campo — SP
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: '1rem' }}>
              Contato
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255,255,255,0.7)' }}>
              <strong style={{ color: '#fff' }}>WhatsApp:</strong> (11) 96511-5307
            </Typography>
            
            <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255,255,255,0.7)' }}>
              <strong style={{ color: '#fff' }}>E-mail:</strong> contato@medprimebeneficios.com.br
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)', mb: 2, fontSize: '0.78rem', lineHeight: 1.6 }}>
          MedPrime Benefícios é a marca comercial utilizada por VITOR DE OLIVEIRA JUNIOR
          INFORMATICA (CNPJ 32.256.713/0001-07) para suas atividades relacionadas aos serviços
          apresentados neste site.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'center' : 'flex-start',
            textAlign: isMobile ? 'center' : 'left',
            gap: 1,
          }}
        >
          <Typography variant="body2" color="rgba(255,255,255,0.45)" fontSize="0.8rem">
            © {currentYear} MedPrime Benefícios. Todos os direitos reservados.
          </Typography>
          <Typography variant="body2" color="rgba(255,255,255,0.45)" fontSize="0.8rem">
            Desenvolvido por{' '}
            <Link href="#" underline="hover" sx={{ color: 'rgba(255,255,255,0.6)' }}>
              VJR Software
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
